<template>
  <div>
    <div class="zj-tree-dailog">
      <el-tree
        ref="tree"
        style="{ width }"
        show-checkbox
        node-key="value"
        :default-expanded-keys="expandkeys"
        :data="Roles"
        :props="defaultProps"
        highlight-current="true"
      >
      </el-tree>
    </div>
    <div style="text-align: center;padding-top:30px;">
      <el-button type="primary" @click="OnSubmit">提交</el-button>
      <el-button @click="OnCancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import utils from "../../../../../../utils";
import WebApis from "../../../apis";
import { showLoading, hideLoading } from "../../../../../../loading";

export default {
  name: "ChoseRolesPage",
  data() {
    return {
      Roles: [],
      defaultProps: {
        children: "children",
        label: "label",
        value: "value",
      },
      expandkeys: [],
    };
  },
  props: {
    User_Id: {
      type: String,
      default: "",
    },
    User_Name: {
      type: String,
      default: "",
    },
  },
  created: function() {
    this.init();
  },
  computed: {},
  methods: {
    init() {
      return utils.waitAll([() => this.GetRoles("")]);
    },
    GetRoles(expand_keys) {
      var OrgCode = this.config.app.org_code;

      let user = this.user;
      var userId = user.UserId;
      showLoading(".zj-form-container");

      let UserRoleInfoSearch = {
        UserId: this.User_Id,
      };

      return new WebApis.UserRoleApi()
        .GetRoleIdsByUserId(UserRoleInfoSearch)
        .then((res) => {
          if (res.RspCode == "1") {
            var roleids = res.data.Data;

            let TreeSearch = {
              UserId: userId,
              OrgCode: OrgCode,
            };

            new WebApis.TreeApi()
              .GetRoleTree(TreeSearch)
              .then((res) => {
                if (res.RspCode == "1") {
                  this.Roles = res.data.Data;
                  this.expandkeys = expand_keys;
                  this.$refs.tree.setCheckedKeys(roleids);
                }
                hideLoading();
              })
              .catch((e) => {
                hideLoading();
                this.$message({
                  showClose: true,
                  message: e.RspMsg
                    ? "获取菜单失败!" + e.RspMsg
                    : "获取菜单失败!",
                  type: "error",
                });
              });
          }
        });
    },
    OnSubmit() {
      let user = this.user;
      var LoginUserName = user.UserName;

      let UserRoleInfoSearch = {
        RoleIds: this.$refs.tree.getCheckedKeys(),
        UserId: this.User_Id,
        UserName: this.User_Name,
        LoginName: LoginUserName,
      };

      console.log(UserRoleInfoSearch);

      showLoading(".zj-form-container");
      new WebApis.UserRoleApi()
        .InsertItemList(UserRoleInfoSearch)
        .then((res) => {
          if (res.RspCode == "1") {
            hideLoading();
            this.$message({
              showClose: true,
              message: "授权成功!",
              type: "success",
            });
            this.$emit("clickOk", {});
          }
          this.logInfo.ActionName = "用户分配角色";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "用户分配角色成功" : "用户分配角色失败";
          this.logInfo.ModuleName = "权限管理";
          this.logInfo.PageName = "用户管理分配角色页面";
          this.addOperationLog();
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg ? "权限分配失败!" + e.RspMsg : "权限分配失败!",
            type: "error",
          });
        });
    },
    OnCancel() {
      this.$emit("clickCancel", {});
    },
  },
};
</script>
